import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { KEY_Z, KEYBOARD_KEY_Z } from '@/constants';
import { usePopupOpen } from '@/hooks';
import { checkCtrlPressed } from '@/helpers';
import { undoStepThunk } from '@/actions';

export default () => {
  const dispatch = useDispatch();
  const isSomePopupOpen = usePopupOpen();

  useEffect(() => {
    if (isSomePopupOpen) {
      removeListener();
    } else {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      removeListener();
    };
  });

  const removeListener = () => {
    document.removeEventListener('keydown', handleKeyDown);
  };

  const handleKeyDown = event => {
    const isCtrlPressed = checkCtrlPressed(event);
    if ((isCtrlPressed && event.code === KEY_Z) || (isCtrlPressed && event.key === KEYBOARD_KEY_Z)) {
      event.preventDefault();
      dispatch(undoStepThunk());
    }
  };
};
